import React from 'react';
import { Box } from '@chakra-ui/react';
import Navbar from "../components/Navbar";
import HarvestersPerformance from '../harvesters_performance/HarvestersPerformance';

const HarvestersPerformancePage: React.FC = () => {
    return (
        <Box h="100vh" display="flex" flexDirection="column">
            <Navbar />
            <Box flex="1" zIndex={1}>
                <HarvestersPerformance />
            </Box>
        </Box>
    );
};

export default HarvestersPerformancePage;
